export class AiUsageMetricsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiUsageByCompany(params) {
    return this.#http.get('/ai-usage/by-company', { params });
  }

  async getAiUsageByCompanyGrouped(params) {
    return this.#http.get('/ai-usage/by-company/grouped', { params });
  }

  async getAiUsageByExtractionSession(sessionId) {
    return this.#http.get(`/ai-usage/by-extraction-session/${sessionId}`);
  }

  async getAiUsageByChatSession(chatSessionId) {
    return this.#http.get(`/ai-usage/by-chat-session/${chatSessionId}`);
  }

  async getAiUsageByExecution(executionId) {
    return this.#http.get(`/ai-usage/by-execution/${executionId}`);
  }

  async getAiUsageSummary(params) {
    return this.#http.get('/ai-usage/summary', { params });
  }

  async getAiUsageByLoan(loanId, params) {
    return this.#http.get(`/ai-usage/by-loan/${loanId}`, { params });
  }

  async getAiUsageByLoanGrouped(loanId, params) {
    return this.#http.get(`/ai-usage/by-loan/${loanId}/grouped`, { params });
  }

  async getAiUsageByUser(userId, params) {
    return this.#http.get(`/ai-usage/by-user/${userId}`, { params });
  }

  async getAiUsageByProcess(processId, params) {
    return this.#http.get(`/ai-usage/by-process/${processId}`, { params });
  }

  async getAiUsageByProcessGrouped(processId, params) {
    return this.#http.get(`/ai-usage/by-process/${processId}/grouped`, { params });
  }

  async getAiUsageByChatAgent(configurationId, params) {
    return this.#http.get(`/ai-usage/by-chat-agent/${configurationId}`, { params });
  }

  async getAiUsageMetricsCalls(aiUsageMetricsId) {
    return this.#http.get(`/ai-usage/${aiUsageMetricsId}/calls`);
  }
}
